import React from 'react';

import PropTypes from 'prop-types';

import DeleteCardOrAccountPopup from 'apps/auth/components/cards/DeleteCardOrAccountPopup';
import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, DiskButtonWrapper, PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { LEAN_WAITING_SCREEN } from 'apps/auth/constants/ComponentNames';
import { PAYMENT_LEAN, STATUS_OK } from 'apps/auth/constants/Constants';
import { URL_IMAGES_BANKS } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import LeanModal from '../../Lean/LeanModal';

const DcLeanAccount = (props) => {
    const { badge = '', actionBanner = '', icon, account, modalRef, popupRef, clickHandler } = props;
    const { continueTransferFlow, changePaymentOption } = usePageMessages();
    const isReviewAccount = account.status !== STATUS_OK;

    const onClickHandler = (e) => {
        if (isReviewAccount) {
            modalRef.current?.open(<LeanModal currentScreen={LEAN_WAITING_SCREEN} modalRef={props.modalRef} />);
        } else if (actionBanner) {
            const actionBannerPopup = (
                <SimplePopup text={<DangerouslyHtml dangerouslyHtml={props.actionBanner} />} withoutCloseButton>
                    <PopupButton
                        iconName="arrow-forward"
                        text={continueTransferFlow}
                        onClick={() => {
                            clickHandler?.(e, PAYMENT_LEAN, account.code);
                            popupRef.current?.close();
                        }}
                    />
                    <PopupButton
                        iconName="retry"
                        text={changePaymentOption}
                        onClick={() => {
                            popupRef.current?.close();
                        }}
                    />
                </SimplePopup>
            );
            popupRef.current?.open(actionBannerPopup);
        } else {
            clickHandler?.(e, PAYMENT_LEAN, account.code);
        }
    };

    const revokeAccessAction = (e) => {
        e.preventDefault();
        e.stopPropagation();
        popupRef.current.open(
            <DeleteCardOrAccountPopup
                popupRef={popupRef}
                isLean={true}
                forDcAccount={true}
                force
                selectedCard={account}
                beforeSubmit={(e) => e.stopPropagation()}
            />,
        );
    };

    const alias = `${account.alias} ·· ${account.description}`;
    return (
        <Panel onClick={onClickHandler} negativeMargin isHoverable>
            <PanelFrame>
                <DiskBadgeWrapper>
                    <DiskBadge
                        isDisabled={isReviewAccount}
                        iconName={!account.accountLogo ? icon : null}
                        src={account.accountLogo ? `${URL_IMAGES_BANKS}/${account.accountLogo}.png` : null}
                        alt={account.accountLogo ? account.accountLogo : null}
                    />
                </DiskBadgeWrapper>
                <PanelContent>
                    <Text color={isReviewAccount ? 'secondary' : 'primary'}>{alias}</Text>
                </PanelContent>
                <PanelRightBlock flex>
                    {!isReviewAccount ? (
                        <>
                            {badge ? <Badge variant="primary" caption={badge} /> : null}
                            <DiskButtonWrapper>
                                <DiskButton type="button" variant="error" iconName="cross" iconColor="error" onClick={revokeAccessAction} raised={false} />
                            </DiskButtonWrapper>
                        </>
                    ) : (
                        <Icon name="info-rounded" size="16px" color="lightGray" />
                    )}
                </PanelRightBlock>
            </PanelFrame>
        </Panel>
    );
};
DcLeanAccount.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    badge: PropTypes.string,
    actionBanner: PropTypes.string,
    clickHandler: PropTypes.func,
    account: PropTypes.object,
    icon: PropTypes.string,
};

export default DcLeanAccount;
